import * as apiCall from "./apiCall"
import * as action from "./modules/actions"

export function dataFetch(params = {}) {
	return function (dispatch) {
		return apiCall.migGET('/refresh', params)
		.then(res => {
			dispatch({
				type: action.DATAFETCH,
				data : res.data
			});
		})
	};
}

export function fetchIgnoredFiles(params) {
	return function (dispatch) {
		return apiCall.migGET('/ignored_files', params)
	}
}

export function resendMigrateGuruVerification(params) {
	return function (dispatch) {
		return apiCall.migGET('/verification', params)
	}
}

export function userInfo(params) {
	return function (dispatch) {
		return apiCall.migGET('/user_info', params)
	}
}

export function fetchDirectoryList(params) {
	return function(dispatch) {
		return apiCall.migGET('/fetch_directory_list', params)
	}
}

export function fetchTablesList(params) {
	return function(dispatch) {
		return apiCall.migGET('/fetch_tables_list', params)
	}
}

export function openModal(params) {
	return {
		type: action.ADDMODAL,
		params: params
	};
}

export function closeModal() {
	return {
		type: action.REMOVEMODAL,
	};
}

export function cancelMigration(params) {
	return function (dispatch) {
		return apiCall.migGET('/cancel', params)
			.then(res => {
				dispatch({
					type: action.DATAFETCH,
					data : res.data
				});
			})
		.catch(res => {
		});
	};
}

export function validateMigration(params){
	return function(dispatch){
		return apiCall.migPOST('/validate', params)
			.then(res => {
				dispatch({
					type: action.DATAFETCH,
					data: res.data
				});
			})
			.catch(error => {
			});
	};
}
